import { makeStyles, Theme } from '@material-ui/core';

export const useMessageStyle = makeStyles<Theme>((theme: Theme) => ({
  root: {},
}));
